export const shouldClearImportedContactDetails = ({
  previousCheckboxValue,
  currentCheckboxValue,
  skipClearOnNextCheckboxOff,
}: {
  previousCheckboxValue?: boolean;
  currentCheckboxValue?: boolean;
  skipClearOnNextCheckboxOff: boolean;
}) =>
  previousCheckboxValue === true &&
  currentCheckboxValue === false &&
  !skipClearOnNextCheckboxOff;

export const getClearedImportedContactDetails = () => ({
  firstName: '',
  lastName: '',
  email: '',
  dateOfBirth: '',
  phone: '',
});
